export const EmptyCases = () => {
    return (
        <svg width="130" height="130" viewBox="0 0 130 130" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_746_23318)">
        <circle cx="65.5" cy="65" r="65" fill="#286D87" fillOpacity="0.1"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M41.75 52.625H89.25V88.25H41.75V52.625Z" fill="black"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M54.126 40.75H77.876V52.625H73.126V45.5H58.876V52.625H54.126V40.75Z" fill="black"/>
        <rect x="81.25" y="41.25" width="23.5" height="23.5" rx="2.15" fill="white"/>
        <rect x="81.25" y="41.25" width="23.5" height="23.5" rx="2.15" stroke="#E5E5E5" strokeWidth="0.5"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M93.5999 47.5996V52.3996H98.3996V53.5996H93.5999V58.3996H92.3999V53.5996H87.5996V52.3996H92.3999V47.5996H93.5999Z" fill="#296D87"/>
        </g>
        <defs>
        <clipPath id="clip0_746_23318">
        <rect width="130" height="130" rx="65" fill="white"/>
        </clipPath>
        </defs>
        </svg>
    );
  };